import type { UserPreferenceType } from '@atlassian/jira-dashboard-user-preference/src/types.tsx';
import type { GadgetDefinition } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import type { CustomReportGadgetData } from './common/types.tsx';
import { LazyCustomReportGadgetEdit } from './ui/edit/async.tsx';
import { LazyCustomReportGadgetView, preload } from './ui/view/async.tsx';
import getInitialState from './utils/get-initial-state.tsx';

const CUSTOM_REPORT_DEFINITION: GadgetDefinition<
	CustomReportGadgetData,
	CustomReportGadgetData,
	UserPreferenceType[]
> = {
	componentView: LazyCustomReportGadgetView,
	componentEdit: LazyCustomReportGadgetEdit,
	getInitialState,
	preload,
};

export default CUSTOM_REPORT_DEFINITION;
